import Sqkhit from "./sqkhit/index";


export default function Layout() {
    return (
        <div className="container-fluid">
          <header className="row mb-5">
            <div className="col-md-6 offset-md-3">
              <h1 className="text-center text-primary mt-5">[Square Khit]</h1>
            </div>
          </header>
          <main className="row">
            <Sqkhit />
          </main>
          <footer className="row">
            <div className="col-12">
              <p className="text-center text-muted">Khit Wong ©{(new Date()).getFullYear()}</p>
              <p className="text-center text-muted text-decoration-underline">
                <a href="mailto:mzinyoni7@outlook.com">Application Done by Mike Zinyoni</a>
              </p>
            </div>
          </footer>
        </div>
    )
}